import { format } from 'date-fns';

// Dates are epoch ms. Booking dates are real moments and show in local time. Dates of birth and
// program dates are calendar days stored at a midnight, so they show in UTC, as the app's
// helper.dateFormat (moment.utc) does.

const currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });

export function formatCurrency(value) {
  return currency.format(Number(value) || 0);
}

const isDate = ms => ms !== null && ms !== undefined && ms !== '' && !Number.isNaN(new Date(ms).getTime());

const utcDay = ms => {
  const d = new Date(ms);
  return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
};

export function formatDate(ms) {
  return isDate(ms) ? format(new Date(ms), 'MMM d, yyyy') : '';
}

export function formatMonth(ms) {
  return isDate(ms) ? format(new Date(ms), 'MMMM yyyy') : '';
}

export function formatTime(ms) {
  return isDate(ms) ? format(new Date(ms), 'h:mm a') : '';
}

export function formatDay(ms) {
  return isDate(ms) ? format(utcDay(ms), 'MMM d, yyyy') : '';
}

export function formatDayRange(fromMs, toMs) {
  if (!isDate(fromMs)) return '';
  const from = utcDay(fromMs);
  if (!isDate(toMs)) return format(from, 'MMM d, yyyy');
  const to = utcDay(toMs);
  if (from.getFullYear() !== to.getFullYear()) return `${format(from, 'MMM d, yyyy')} – ${format(to, 'MMM d, yyyy')}`;
  if (from.getMonth() !== to.getMonth()) return `${format(from, 'MMM d')} – ${format(to, 'MMM d')}`;
  if (from.getDate() !== to.getDate()) return `${format(from, 'MMM d')}–${format(to, 'd')}`;
  return format(from, 'MMM d');
}

export function fullName(r) {
  return `${r.participant.firstName} ${r.participant.lastName}`.trim();
}

export function pluralize(count, word, plural = `${word}s`) {
  return `${count} ${count === 1 ? word : plural}`;
}
